import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { checkedOutItemShape } from '@bibliocommons/bc-prop-types';
import Rating from '@bibliocommons/rating';

import DigitalItemInfo from '../DigitalItemInfo';
import ItemField from '../../shared/ItemField';
import ItemFormat from '../../../shared/ItemFormat';

import './CheckedOutAdditionalBriefInfo.scss';

export default class CheckedOutAdditionalBriefInfo extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleUpdateRating', 'handleRemoveRating');
  }

  renderVolume() {
    const volume = this.props.item.get('volume');
    return volume && (
      <ItemField className="volume-field" name={<FormattedMessage id="volume" />} value={volume} />
    );
  }

  renderCopy() {
    const copy = this.props.item.get('copy');
    return copy && (
      <ItemField className="copy-field" name={<FormattedMessage id="copy" />} value={copy} />
    );
  }

  isDigital() {
    return this.props.item.getIn(['bib', 'policy', 'materialType']) === 'DIGITAL';
  }

  renderCallNumberAndBarcode() {
    const { item } = this.props;

    if (!this.isDigital()) {
      return (
        <div data-test-id="call-number-and-barcode" className="call-number-and-barcode">
          <ItemField
            name={<FormattedMessage id="CALL_NUMBER" />}
            value={item.get('callNumber')} />

          <ItemField
            name={<FormattedMessage id="form_label_barcode" />}
            value={item.get('barcode')} />
        </div>
      );
    }

    return null;
  }

  renderBibFields() {
    const { item } = this.props;
    const bib = item.get('bib');

    if (bib) {
      return (
        <div className="format-field">
          <ItemFormat bib={item.get('bib')} />
          {this.renderRating()}
          <DigitalItemInfo
            format={item.get('format')}
            bib={bib} />
        </div>
      );
    }

    return null;
  }

  handleUpdateRating(rating) {
    if (this.props.rating) {
      return this.props.ratingsActions.changeItemRating(this.props.item.get('metadataId'), rating);
    }

    return this.props.ratingsActions.rateItem(this.props.item.get('metadataId'), rating);
  }

  handleRemoveRating() {
    return this.props.ratingsActions.removeItemRating(this.props.item.get('metadataId'), this.props.rating.get(0).get('id'));
  }

  renderRating() {
    const { item, ratingsTransactions, rating } = this.props;
    if (item.get('bib')) {
      const currentUserRating = rating ? rating.get(0).get('rating') : null;
      const metadataId = item.get('metadataId');
      const isLoading = ratingsTransactions.getIn([metadataId, 'isLoading'], false);
      return (
        <div className="post-success-rating">
          <FormattedMessage id="label_rate_this" />
          <Rating
            id={`added_to_shelf_rating_${metadataId}`}
            isLoading={isLoading}
            rating={currentUserRating}
            handleButtonClick={this.handleUpdateRating}
            handleRemoveClick={this.handleRemoveRating} />
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <div className="cp-checked-out-additional-brief-info">
        {this.renderVolume()}
        {this.renderCopy()}
        {this.renderBibFields()}
        {this.renderCallNumberAndBarcode()}
      </div>
    );
  }
}

CheckedOutAdditionalBriefInfo.propTypes = {
  item: checkedOutItemShape,
  rating: ImmutablePropTypes.list,
  ratingsActions: PropTypes.objectOf(PropTypes.func),
  ratingsTransactions:  ImmutablePropTypes.map
};

CheckedOutAdditionalBriefInfo.defaultProps = {
  renderRating: () => null
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutAdditionalBriefInfo/CheckedOutAdditionalBriefInfo.jsx